import { render, staticRenderFns } from "./FeedBackUpApp.vue?vue&type=template&id=3a1cd28e&scoped=true&"
import script from "./FeedBackUpApp.vue?vue&type=script&lang=ts&"
export * from "./FeedBackUpApp.vue?vue&type=script&lang=ts&"
import style0 from "./FeedBackUpApp.scss?vue&type=style&index=0&id=3a1cd28e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1cd28e",
  null
  
)

export default component.exports